// extracted by mini-css-extract-plugin
export default {"calculatorContainer":"EnergyBenefitsWidget_calculatorContainer__lqnom","faded":"EnergyBenefitsWidget_faded__Izy3p","info":"EnergyBenefitsWidget_info__neHer"};